// stores/itemStore.js
import { create } from "zustand";
import axios from "axios";
import authHeader from "../../services/auth-header";
import { APP_URL } from "../../services/http-common";
import useGlobalStore from "./globalStoreZs";

const URLEntityName = APP_URL + "form-submission";

const useFormInputesSubmissionStore = create((set, get) => ({
  formInputesSubmissionZs: [],
  formSubmissionZs: {},
  linesZs: [],
  items: [],
  total: 0,
  loading: false,

  searchTextLinesZs: "",
  currentPageLinesZs: 0,
  pageSizeLinesZs: 10,
  setSearchTextLinesZs: (text) => {
    set({ searchTextLinesZs: text, currentPageLinesZs: 0 });
    // get().setFilterLinesZs();
  },
  setPageLinesZs: (page) => {
    set({ currentPageLinesZs: page });
    get().setFilterLinesZs();
  },
  totalPagesLinesZs: () => {
    const { linesZs, searchTextLinesZs, pageSizeLinesZs } = get();
    const filtered = linesZs.filter((item) =>
      item?.name?.toLowerCase().includes(searchTextLinesZs.toLowerCase()),
    );
    return Math.ceil(filtered.length / pageSizeLinesZs);
  },
  filterLinesZs: [],
  setFilterLinesZs: () => {
    const { linesZs, searchTextLinesZs, currentPageLinesZs, pageSizeLinesZs } =
      get();
    const filtered = linesZs.filter((row) => {
      return Object.keys(row)
        .filter((key) => key !== "id") // Exclude 'id' from the search
        .some((key) => {
          const value = row[key];
          // Check if the value is a string and contains the search text
          return (
            typeof value === "string" &&
            value.toLowerCase().includes(searchTextLinesZs.toLowerCase())
          );
        });
    });
    const totalPages = Math.ceil(filtered.length / pageSizeLinesZs);

    // Ensure the current page does not exceed total pages
    const currentPage = Math.min(currentPageLinesZs, totalPages - 1);

    const start = currentPageLinesZs * pageSizeLinesZs;
    const end = start + pageSizeLinesZs;

    set({
      filterLinesZs: filtered.slice(start, end),
      totalPagesLinesZs: totalPages,
      currentPageLinesZs: currentPage,
      total: filtered.length,
    });
  },

  fetchForminputesSubmissionsZs: async (page = 0, search = "") => {
    useGlobalStore.getState().setLoadingZs(true);
    set({ loading: true });
    try {
      const response = await axios.get(URLEntityName + "/dashboard", {
        headers: authHeader(),
      });
      set({ formInputesSubmissionZs: response.data });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },
  getFormSubmissionZs: async (id) => {
    const { pageSizeLinesZs } = get();

    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.get(URLEntityName + "/" + id, {
        headers: authHeader(),
      });
      const newLines = response?.data?.lines
        .map((line) => {
          const row = { id: line.id, order: line?.order };
          line.answers.forEach((answer) => {
            row[answer.formInputId] = answer.answer;
          });
          return row;
        })
        .sort((a, b) => a.order - b.order);
      set({
        formSubmissionZs: response.data,
        linesZs: newLines,
        filterLinesZs: newLines.slice(0, pageSizeLinesZs),
        total: newLines.length,
        searchTextLinesZs: "",
        currentPageLinesZs: 0,
      });
    } catch (error) {
      console.error("Error fetching items", error);
    }
    set({ loading: false });
    useGlobalStore.getState().setLoadingZs(false);
  },

  submitInputeLinesZs: async (
    item,
    successMessage = "Rekordi u shtua me sukses!",
  ) => {
    set({ loading: true });
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const response = await axios.post(
        URLEntityName + "/" + item?.id + "/lines",
        item?.lines,
        {
          headers: authHeader(),
        },
      );
      await useFormInputesSubmissionStore
        .getState()
        .getFormSubmissionZs(item?.id);
      useGlobalStore.getState().setLoadingZs(false);
      useGlobalStore.getState().setMessageZs(successMessage);
    } catch (error) {
      console.error("Error fetching items", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },

  deleteFormInputLineZs: async (item, silent = false) => {
    useGlobalStore.getState().setLoadingZs(true);
    try {
      const url = URLEntityName + "/lines/" + item.lineId;
      const response = await axios.delete(url, { headers: authHeader() });
      if (!silent) {
        await useFormInputesSubmissionStore
          .getState()
          .getFormSubmissionZs(item?.formId);
        useGlobalStore.getState().setLoadingZs(false);
        useGlobalStore.getState().setMessageZs("Rekordi u fshi me sukses!");
      }
      return response;
    } catch (error) {
      console.error("Error delete ", error);
      const message =
        (error.response &&
          error.response.data &&
          error.response.data.message) ||
        error.message ||
        error.toString();
      useGlobalStore.getState().setMessageZs(message);
      throw error;
    }
    useGlobalStore.getState().setLoadingZs(false);
    set({ loading: false });
  },
}));

export default useFormInputesSubmissionStore;
